import HybridConfig from "lib/HybridConfig";

class AbstractionAIServices {

    constructor() {
        this.enabled = HybridConfig.get(`aiAnalytics.enabled`, false);
        this.url = HybridConfig.get(`apiRoot`, false) + "analytics/";
    }
    sendAccept(fieldSuggestionId, acceptIndices = []) {
        return this.sendRequest("accept", {
            fieldSuggestionId,
            acceptIndices,
        });
    }

    sendFeedback(evidenceId, feedback) {
        return this.sendRequest("feedback", {
            evidenceId,
            feedback: feedback
        });
    }

    sendImpression(hasPermission = false, fieldSuggestionId) {
        return this.sendRequest("impression", {
            group: hasPermission,
            fieldSuggestionId
        });
    }

    sendRequest(path, payload) {
        if(!this.enabled) {
            return new Promise((resolve) => {resolve();});
        }
        return $.ajax({
            type: "POST",
            url: this.url + path,
            dataType: "json",
            contentType: "application/json",
            data: JSON.stringify({
                ...payload
            }),
            background: true,
            ignoreFailure: true,
        });
    }
}

export default new AbstractionAIServices();



// WEBPACK FOOTER //
// ./app/lib/AbstractionAIService.js